// API call for fetching the list of soft tags
import authorizedAPIInstance from '@/api/authorizedAPI';
import { mapTagsDTOArray } from '../utils/tags.mappers';
import type {
  CreateSearchTagParams,
  GetSoftTagParams,
  GetSoftTagResponse,
  SoftTagsParams,
  SoftTagsResponse,
  SoftTagsResponseDTO,
} from '../types/tags.types';
import { mapTagToSoftTagState } from '@/features/createTags/utils/helpers';
import type { SoftTagState } from '@/features/createTags/utils/types';

// Fetches soft tags from backend, maps DTO to response shape
// params: optional query parameters for filtering/search
// Returns: Promise resolving to SoftTagsResponse
export const getSoftTagsList = async (
  params?: SoftTagsParams
): Promise<SoftTagsResponse> => {
  const { data } = await authorizedAPIInstance.get<SoftTagsResponseDTO>(
    '/soft-tags',
    {
      params,
    }
  );
  // Map DTO array to frontend response format
  const responseData: SoftTagsResponse = mapTagsDTOArray(data);
  return responseData;
};

export const getSearchTagList = async (
  params?: CreateSearchTagParams
): Promise<any[]> => {
  const { data } = await authorizedAPIInstance.get<any[]>('/tags/search', {
    params,
  });
  return data;
};

export const getSoftTagAPI = async (
  params?: GetSoftTagParams
): Promise<SoftTagState> => {
  const { data } = await authorizedAPIInstance.get<GetSoftTagResponse>(
    `/soft-tag/${params?.id}`,
    {}
  );
  const responseData: SoftTagState = mapTagToSoftTagState(data);
  return responseData;
};

export const uploadBulkImport = async (
  formData: FormData
): Promise<unknown> => {
  const { data } = await authorizedAPIInstance.post(
    '/soft-tag/bulk/import',
    formData
  );
  return data;
};
